module.exports = __webpack_public_path__ + "static/img/icon-contract-s.487b70b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-contract-s.png
// module id = 3icT
// module chunks = 21